export default __webpack_public_path__ + "static/media/arrow_forward.8739e472.svg";